import React, { useMemo, useState } from 'react';
import ChatMessageBubble from '../../ChatMessageBubble';
import { LinkPreviewCard, LinkPreviewCover } from './style';

interface ChatRenderLinkPreviewProps {
  message: {
    link: {
      title: string;
      description: string;
      url: string;
      image?: string;
      imageWidth?: number;
      imageHeight?: number;
    };
  };
}

const ChatRenderLinkPreview = function ({
  message,
}: ChatRenderLinkPreviewProps) {
  const { link } = message;
  const [hasError, setHasError] = useState(false);

  const orientation = useMemo(() => (
    link.imageWidth! < 250 || link.imageWidth! < link.imageHeight!
      ? 'portrait'
      : 'landscape'
  ), [link]);

  return (
    <ChatMessageBubble borderless transparent>
      <LinkPreviewCard>
        <a href={link.url} target="_blank" rel="noreferrer">
          {link.image && !hasError && (
            <LinkPreviewCover orientation={orientation}>
              <img
                alt={link.title}
                src={link.image}
                onError={() => setHasError(true)}
              />
            </LinkPreviewCover>
          )}
          <div className="chat-message-link-preview-body bubble-background">
            <h3 className="chat-message-text-message">{link.title}</h3>
            {link.description && (
              <p className="chat-message-text-message">{link.description}</p>
            )}
          </div>
        </a>
      </LinkPreviewCard>
    </ChatMessageBubble>
  );
};

export default ChatRenderLinkPreview;
